import { InfoIcon } from "lucide-react";
import { observer, useLocalObservable } from "mobx-react-lite";

import { SchemaEditorProvider } from "../SchemaEditor";
import SchemaEditorStore from "../SchemaEditor/schema-editor-store";
import SchemaParameter from "../SchemaEditor/SchemaParameter";
import { CopyButton } from "../ui/copy-button";
import { BasicTooltip } from "../ui/Tooltip";

import { JSONSchema } from "@/types";

export const JSONSchemaCell = observer(
  ({
    jsonSchema,
    componentIsOpen,
    isGoogle,
  }: {
    jsonSchema: JSONSchema;
    componentIsOpen: boolean;
    isGoogle?: boolean;
  }) => {
    const schemaEditorStore = useLocalObservable(
      () => new SchemaEditorStore(jsonSchema, false, true),
    );

    return (
      <SchemaEditorProvider value={schemaEditorStore}>
        <div className="relative mt-2">
          <div className="text-gray-900">
            <div className="flex items-start justify-between">
              {componentIsOpen ? (
                <div className="flex w-full flex-col">
                  {schemaEditorStore.schemaParameters.length > 0 &&
                    schemaEditorStore.schemaParameters.map(parameter => (
                      <SchemaParameter key={parameter.name} parameter={parameter} />
                    ))}
                  <div className="absolute right-[20px] top-[-45px]">
                    <CopyButton text={JSON.stringify(jsonSchema, null, 2)} />
                  </div>
                </div>
              ) : (
                <div className="flex w-full flex-col items-start">
                  <span className="flex items-center text-sm text-gray-500">
                    Name: {isGoogle ? "Not Supported" : schemaEditorStore.name}
                    {isGoogle && (
                      <BasicTooltip content="Google does not support names for JSON Schema.">
                        <InfoIcon className="ml-1 h-4 w-4 text-gray-500 hover:text-gray-900" />
                      </BasicTooltip>
                    )}
                  </span>
                  <span className="text-sm text-gray-500">
                    Description:{" "}
                    {schemaEditorStore.description ? schemaEditorStore.description : "-"}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </SchemaEditorProvider>
    );
  },
);
